export default "__VITE_ASSET__XtrD8AIl__"